module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border heading-cart"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Publisher Reports Approval")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "icon": "el-icon-upload"
    },
    on: {
      "click": function($event) {
        return _vm.confirmReUpload("updated", _vm.report_date)
      }
    }
  }, [_vm._v("Re - Upload Report")]), _vm._v(" "), (_vm.getOverAllReportStatus(_vm.report_date) == 'Approved') ? _c('el-button', {
    staticClass: "approve-all-reports",
    attrs: {
      "type": "success",
      "icon": _vm.approveAllBtn
    },
    on: {
      "click": function($event) {
        return _vm.approveAllData(_vm.report_date, $event)
      }
    }
  }, [_vm._v(_vm._s(_vm.getOverAllReportStatus(_vm.report_date)))]) : _c('el-button', {
    staticClass: "approve-all-reports",
    attrs: {
      "type": "primary",
      "icon": _vm.approveAllBtn
    },
    on: {
      "click": function($event) {
        return _vm.approveAllData(_vm.report_date, $event)
      }
    }
  }, [_vm._v(_vm._s(_vm.getOverAllReportStatus(_vm.report_date)))])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-body p-b-15",
    staticStyle: {
      "max-height": "80vh",
      "overflow": "auto"
    }
  }, [(_vm.publisherDomainList.length != 0) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, _vm._l((_vm.publisherDomainList), function(data) {
    return _c('el-collapse-item', {
      staticClass: "collapse--item",
      attrs: {
        "title": data.publisher,
        "name": data.publisher
      }
    }, _vm._l((data.domains), function(i, index) {
      return (_vm.getFilteredReport(_vm.reportData, i).length > 0) ? _c('div', [_c('el-collapse', {
        attrs: {
          "accordion": ""
        }
      }, [_c('el-collapse-item', {
        staticClass: "collapse--item"
      }, [_c('template', {
        slot: "title"
      }, [_c('div', {
        staticStyle: {
          "width": "100%"
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tReport for " + _vm._s(i) + "\n\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('el-table', {
        staticStyle: {
          "width": "100%",
          "border-spacing": "0"
        },
        attrs: {
          "data": _vm.getFilteredReport(_vm.reportData, i),
          "id": ""
        }
      }, [_c('el-table-column', {
        staticClass: "text-center",
        attrs: {
          "label": "Report Date"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(props) {
            return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getFormattedDate(props.row.date)) + "\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]
          }
        }], null, true)
      }), _vm._v(" "), _c('el-table-column', {
        staticClass: "text-center",
        attrs: {
          "label": "Site",
          "prop": "site"
        }
      }), _vm._v(" "), _c('el-table-column', {
        staticClass: "text-center",
        attrs: {
          "label": "Dimension",
          "prop": "dimension"
        }
      }), _vm._v(" "), _c('el-table-column', {
        staticClass: "text-center",
        attrs: {
          "label": "Bidder",
          "prop": "bidder"
        }
      }), _vm._v(" "), _c('el-table-column', {
        staticClass: "text-center",
        attrs: {
          "label": "Bidder Impression",
          "prop": "bidder_impression"
        }
      }), _vm._v(" "), _c('el-table-column', {
        staticClass: "text-center",
        attrs: {
          "label": "Bidder Revenue",
          "prop": "bidder_revenue"
        }
      }), _vm._v(" "), _c('el-table-column', {
        staticClass: "text-center",
        attrs: {
          "label": "DFP Impression",
          "prop": "dfp_impression"
        }
      }), _vm._v(" "), _c('el-table-column', {
        staticClass: "text-center",
        attrs: {
          "label": "DFP Revenue",
          "prop": "dfp_revenue"
        }
      }), _vm._v(" "), _c('el-table-column', {
        staticClass: "text-center",
        attrs: {
          "label": "Bidder eCPM"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(props) {
            return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getExchangeRate(_vm.currencyArr, i)[0] + " " + _vm.getRoundedNumbers((props.row.bidder_revenue / props.row.bidder_impression) * 1000)) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]
          }
        }], null, true)
      }), _vm._v(" "), _c('el-table-column', {
        staticClass: "text-center",
        attrs: {
          "label": "DFP eCPM"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(props) {
            return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getExchangeRate(_vm.currencyArr, i)[0] + " " + _vm.getRoundedNumbers((props.row.dfp_revenue / props.row.dfp_impression) * 1000)) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]
          }
        }], null, true)
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "container"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-md-4 col-sm-6 col-xs-12"
      }, [_c('h5', [_vm._v("DFP Total:")]), _vm._v(" "), _c('p', [_vm._v("Total Revenue: " + _vm._s(_vm.getRevenueTotal(_vm.getFilteredReport(_vm.reportData, i), 'dfp_revenue')))]), _vm._v(" "), _c('p', [_vm._v("Total Impressions: " + _vm._s(_vm.getValTotal(_vm.getFilteredReport(_vm.reportData, i), 'dfp_impression')))])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-4 col-sm-6 col-xs-12"
      }, [_c('h5', [_vm._v("Bidder Total:")]), _vm._v(" "), _c('p', [_vm._v("Total Revenue: " + _vm._s(_vm.getRevenueTotal(_vm.getFilteredReport(_vm.reportData, i), 'bidder_revenue')))]), _vm._v(" "), _c('p', [_vm._v("Total Impressions: " + _vm._s(_vm.getValTotal(_vm.getFilteredReport(_vm.reportData, i), 'bidder_impression')))])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-4 col-sm-6 col-xs-12"
      }, [_c('div', [_c('h5', [_vm._v("Exchange Rate for USD to " + _vm._s(_vm.getExchangeRate(_vm.currencyArr, i)[0]) + ": ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getExchangeRate(_vm.currencyArr, i)[0] + " " + _vm.getExchangeRate(_vm.currencyArr, i)[1]))])]), _vm._v(" "), _c('div', [_c('el-button', {
        attrs: {
          "type": "success",
          "icon": _vm.approveBtn
        },
        on: {
          "click": function($event) {
            return _vm.approveData(i, _vm.report_date, $event)
          }
        }
      }, [_vm._v(_vm._s(_vm.getReportApprovalStatus(i)))])], 1)])])])], 2)], 1)], 1) : _vm._e()
    }), 0)
  }), 1) : _c('div', {
    staticClass: "p-t-20 p-t-5"
  }, [_vm._v("No data available")]), _vm._v(" "), _c('el-dialog', {
    staticClass: "report-upload-popup",
    attrs: {
      "visible": _vm.UploadScreenVisible,
      "before-close": _vm.clearFilesList
    },
    on: {
      "update:visible": function($event) {
        _vm.UploadScreenVisible = $event
      }
    }
  }, [_c('span', {
    staticClass: "el-dialog__title text-center"
  }, [_vm._v("Upload updated report for " + _vm._s(_vm.report_date))]), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.uploading),
      expression: "uploading"
    }],
    ref: "upload",
    staticClass: "upload-demo m-t-20",
    attrs: {
      "drag": "",
      "limit": 1,
      "action": "reports/v1/upload/",
      "auto-upload": false,
      "http-request": _vm.upload,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "file-list": _vm.fileList
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("Drop file here or "), _c('em', [_vm._v("click to upload")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("Upload modified DFP + Bidder Report")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelUploadAction
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("Upload Report")])], 1)], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7919f366!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/reports/BidderDfpReport.vue
// module id = 713
// module chunks = 2